module.exports = __webpack_public_path__ + "img/comment.7bb7b327.svg";